import { MemberMemberUsers as MemberMemberUsersComponent } from '../../../components/Member';

export function MemberMemberUsers() {
  return <MemberMemberUsersComponent />;
}
